/**
 * Format a number using the Indian numbering system (Lakhs & Crores).
 * e.g. 1234567 → "₹12,34,567"
 */
export function formatIndianCurrency(n: number): string {
  if (n < 0) return `-${formatIndianCurrency(-n)}`;
  const str = Math.round(n).toString();
  if (str.length <= 3) return `₹${str}`;

  // Last 3 digits
  const last3 = str.slice(-3);
  const rest = str.slice(0, -3);

  // Group remaining digits in pairs from right
  const pairs = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  return `₹${pairs},${last3}`;
}

/**
 * Format with abbreviation: Cr / L / K
 */
export function formatIndianShort(n: number): string {
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(1)} Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(1)} L`;
  if (n >= 1000) return `₹${(n / 1000).toFixed(1)}K`;
  return `₹${Math.round(n).toLocaleString("en-IN")}`;
}
